<template lang="pug">
    .drawer-container
        el-button(
            type="success"
            icon="el-icon-fa-list-alt far"
            size="large"
            @click="openCashBookDrawer"
        ) {{ $t('Cash Book') }}
        el-drawer.cash-book-drawer(
            :title="$t('Cash Book')"
            :visible.sync="drawer.visibility"
            :modal="true"
            size="50%"
            @close="$emit('focus-search')"
            @closed="resetCashBookDrawer"
        )
            .drawer-body(v-loading="drawer.loading")
                el-tabs(
                    v-if="!drawer.loading"
                    v-model="drawer.tab"
                    tab-position="left"
                    stretch
                    @tab-click="changeCashBookDrawerTab"
                )
                    //- v-if="cashFlowLogs.pagination || cashFlowLogs.paymentMethod.digital === false"
                    el-tab-pane(
                        v-for="cashFlowLogs in drawer.paginatedCashFlowLogs"
                        :key="cashFlowLogs.paymentMethod.id"
                        :name="cashFlowLogs.paymentMethod.id"
                        :label="cashFlowLogs.paymentMethod.name"
                    )
                        .tab(slot="label")
                            el-button(type="info" plain)
                                label {{ cashFlowLogs.paymentMethod.name }}
                                template(v-for="cashReport in drawer.form.cashReports")
                                    .total(v-if="cashReport.paymentMethod.id === cashFlowLogs.paymentMethod.id && cashReport.should")
                                        | {{ cashReport.should | moneyFormat(cashReport.currency_code) }}
                        .tab-content.scroll-box(
                            :ref="`cash-flow-logs-${cashFlowLogs.paymentMethod.id}`"
                            @scroll="handleCashBookDrawerScroll($event, cashFlowLogs)"
                            v-dragscroll
                        )
                            //- v-if="drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id] && cashFlowLogs.paymentMethod.digital === false"
                            template(v-if="drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id]")
                                h4.title.no-margin-top {{ $t('Withdrawal / Deposit') }}
                                el-form(
                                    label-position="top"
                                    :model="drawer.form.cashFlowLogs"
                                    :rules="drawer.rules.cashFlowLogs"
                                    :ref="`cash-flow-logs-${cashFlowLogs.paymentMethod.id}-form`"
                                )
                                    .form-row
                                        el-form-item(:label="$t('Amount')" :prop="`${cashFlowLogs.paymentMethod.id}.amount`")
                                            //- el-input-number(v-model="drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id].amount" step="0.01" min="0" controls-position="right")
                                            el-input.hidden(v-model="drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id].amount")
                                            .el-form-item__content
                                                .el-input.el-input--medium
                                                    money.el-input__inner(
                                                        v-model="drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id].amount"
                                                        v-bind="getMoneyConfig(drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id].currency)"
                                                    )
                                        el-form-item.dont-grow(:label="$t('Currency')")
                                            el-select(
                                                placeholder=""
                                                v-model="drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id].currency"
                                                autocomplete="no-fill"
                                                value-key="id"
                                                :disabled="currencyOptions.length <= 1"
                                            )
                                                el-option(
                                                    v-for="currency in currencyOptions"
                                                    :key="currency.id"
                                                    :label="currency.iso4217"
                                                    :value="currency"
                                                )
                                    .form-row
                                        el-form-item(:label="$t('Comment')" :prop="`${cashFlowLogs.paymentMethod.id}.comment`")
                                            el-input(
                                                type="textarea"
                                                v-model="drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id].comment"
                                                :autosize="{ minRows: 3, maxRows: 8 }"
                                                maxlength="255"
                                                show-word-limit
                                            )
                                    .flex-row.actions
                                        el-button(
                                            size="large"
                                            icon="el-icon-fa-times fas"
                                            @click="closeCashBookDrawer"
                                        ) {{ $t('Dismiss') }}
                                        .grow
                                        el-button(
                                            size="large"
                                            :disabled="drawer.loading || drawer.saving || ! canWithdrawThatAmount(cashFlowLogs.paymentMethod)"
                                            :loading="drawer.saving"
                                            type="danger"
                                            icon="el-icon-fa-minus fas"
                                            @click="withdrawCash(drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id])"
                                        )
                                            template(v-if="cashFlowLogs.paymentMethod.digital === false") {{ $t('Withdraw Cash') }}
                                            template(v-else) {{ $t('Refund') }}
                                        el-button(
                                            size="large"
                                            :disabled="drawer.loading || drawer.saving || withdrawOnly"
                                            :loading="drawer.saving"
                                            type="success"
                                            icon="el-icon-fa-plus fas"
                                            @click="depositCash(drawer.form.cashFlowLogs[cashFlowLogs.paymentMethod.id])"
                                        )
                                            template(v-if="cashFlowLogs.paymentMethod.digital === false") {{ $t('Deposit Cash') }}
                                            template(v-else) {{ $t('Charge') }}

                                h4.title {{ $t('Cash Flow Logs') }}
                            template(v-else)
                                h4.title.no-margin-top {{ $t('Cash Flow Logs') }}
                            template(v-if="cashFlowLogs.pagination" )
                                template(v-for="(cashFlowLog, i) in cashFlowLogs.pagination.items")
                                    template(v-if="cashFlowLog.cashReport && i === 0")
                                        .alert.warning.no-margin-top {{ $t('There is no cash flow since the last report') }}
                                        cash-flow-log-report-rows(:cash-report="cashFlowLog.cashReport" :cash-flow-logs="cashFlowLogs.pagination.items")
                                        //- .cash-flow-log.is-reported.reported-header
                                        //-     hr
                                        //-     .row
                                        //-         .direction
                                        //-             i.report.fas.el-icon-fa-check
                                        //-         //- .amount {{ $t('Cash Report') }} \#{{ cashFlowLog.cashReport.id }}
                                        //-         .amount
                                        //-             template(v-if="cashFlowLog.cashReport.is !== cashFlowLog.cashReport.should")
                                        //-                 | {{ cashFlowLog.cashReport.is | moneyFormat(cashFlowLog.cashReport.currency_code) }}
                                        //-                 | / {{ cashFlowLog.cashReport.should | moneyFormat(cashFlowLog.cashReport.currency_code) }}
                                        //-             template(v-else)
                                        //-                 | {{ cashFlowLog.cashReport.is | moneyFormat(cashFlowLog.cashReport.currency_code) }}
                                        //-         .report.gray {{ $t('Cash Report') }} \#{{ cashFlowLog.cashReport.id }}
                                        //-         .at {{ cashFlowLog.cashReport.created_at | timestamp2date($t('yyyy-MM-dd') + ', HH:mm') }}
                                        //-     .row
                                        //-         .by
                                        //-             template(v-if="cashFlowLog.cashReport.administrator_name") {{ cashFlowLog.cashReport.administrator_name }}
                                        //-         .comment
                                        //-             template(v-if="cashFlowLog.cashReport.comment") {{ cashFlowLog.cashReport.comment }}
                                    template(v-else-if="cashFlowLog.cashReport && i > 0 && (! cashFlowLogs.pagination.items[i-1].cashReport || cashFlowLogs.pagination.items[i-1].cashReport.uuid !== cashFlowLog.cashReport.uuid)")
                                        cash-flow-log-report-rows(:cash-report="cashFlowLog.cashReport" :cash-flow-logs="cashFlowLogs.pagination.items")
                                        //- .cash-flow-log.is-reported.reported-header
                                        //-     hr
                                        //-     .row
                                        //-         .direction
                                        //-             i.report.fas.el-icon-fa-check
                                        //-         //- .amount {{ $t('Cash Report') }} \#{{ cashFlowLog.cashReport.id }}
                                        //-         .amount
                                        //-             template(v-if="cashFlowLog.cashReport.is !== cashFlowLog.cashReport.should")
                                        //-                 | {{ cashFlowLog.cashReport.is | moneyFormat(cashFlowLog.cashReport.currency_code) }}
                                        //-                 | / {{ cashFlowLog.cashReport.should | moneyFormat(cashFlowLog.cashReport.currency_code) }}
                                        //-             template(v-else)
                                        //-                 | {{ cashFlowLog.cashReport.is | moneyFormat(cashFlowLog.cashReport.currency_code) }}
                                        //-         .report.gray {{ $t('Cash Report') }} \#{{ cashFlowLog.cashReport.id }}
                                        //-         .at {{ cashFlowLog.cashReport.created_at | timestamp2date($t('yyyy-MM-dd') + ', HH:mm') }}
                                        //-     .row
                                        //-         .by
                                        //-             template(v-if="cashFlowLog.cashReport.administrator_name") {{ cashFlowLog.cashReport.administrator_name }}
                                        //-         .comment
                                        //-             template(v-if="cashFlowLog.cashReport.comment") {{ cashFlowLog.cashReport.comment }}
                                    .cash-flow-log(:class="{ 'is-reported': cashFlowLog.cashReport }")
                                        hr
                                        .row
                                            .direction
                                                i.in.fas.el-icon-fa-plus(v-if="cashFlowLog.direction === 'in'")
                                                i.out.fas.el-icon-fa-minus(v-else)

                                            .amount {{ cashFlowLog.amount | moneyFormat(cashFlowLog.currency_code) }}
                                            .purchase
                                                span.gray(v-if="cashFlowLog.purchase") {{ $t('Purchase') }} \#{{ cashFlowLog.purchase.id }}
                                            a.report.highlight(
                                                v-if="cashFlowLog.latestTillRoll"
                                                href
                                                @click.stop.prevent="printCashMovementReceipt(cashFlowLog)"
                                            ) {{ $t('Print Receipt \#{id}', { id: cashFlowLog.id }) }}
                                            .at {{ cashFlowLog.created_at | timestamp2date($t('yyyy-MM-dd') + ', HH:mm') }}
                                        .row
                                            .by
                                                template(v-if="cashFlowLog.administrator_name") {{ cashFlowLog.administrator_name }}
                                            .comment
                                                template(v-if="cashFlowLog.name === 'cash report' && cashFlowLog.description === 'keep'") {{ $t('Cash Report Transfer') }}
                                                template(v-else-if="cashFlowLog.comment") {{ cashFlowLog.comment }}
                                hr
                                //- pre TEST: {{ cashFlowLogs.pagination.loading }}
                                .drawer-spinner-container(v-if="cashFlowLogs.pagination.loading")
                                    .spinner-background
                                        .spinner
                            template(v-else)
                                .alert.warning.no-margin-top {{ $t('There is no cash flow') }}
                    el-tab-pane(name="cash-report" :label="$t('Cash Report')")
                        .tab(slot="label")
                            el-button(type="info" plain)
                                label {{ $t('Cash Report') }}
                        .tab-content.scroll-box(v-dragscroll)
                            template(v-if="drawer.form.cashReports.length")
                                el-form(
                                    label-position="top"
                                    :model="drawer.form"
                                    :rules="drawer.rules"
                                    ref="cashReportForm"
                                )
                                    //- h4.title.no-margin-top {{ $t('Cash Report') }}
                                    //- hr
                                        //
                                    .cash-report(v-for="(cashReport, i) in drawer.form.cashReports")
                                        h2.title.no-margin-top
                                            .name {{ cashReport.payment_method_name }}
                                                span.gray {{ cashReport.currency_code }}
                                                .timespan.small
                                                    | {{ cashReport.period_starts_at | timestamp2date($t('yyyy-MM-dd') + ', HH:mm') }}
                                                    | - {{ cashReport.period_ends_at | timestamp2date($t('yyyy-MM-dd') + ', HH:mm') }}
                                            .should {{ cashReport.should | moneyFormat(cashReport.currency_code) }}
                                        .form-row
                                            el-form-item(:label="$t('Checked sum of the payment method \"{method}\"', { method: cashReport.payment_method_name })" :prop="`cashReports.${i}.is`")
                                                //- el-input-number(v-model="cashReport.is" step="0.01" min="0" controls-position="right")
                                                el-input.hidden(v-model="cashReport.is")
                                                .el-form-item__content
                                                    .el-input.el-input--medium(:class="{ 'is-disabled': !cashReport.paymentMethod.digital && cashReport.use_denomination }")
                                                        money.el-input__inner(
                                                            v-model="cashReport.is"
                                                            v-bind="getMoneyConfig(cashReport.currency)"
                                                            :disabled="!cashReport.paymentMethod.digital && cashReport.use_denomination"
                                                            @change.native="updateCashBookDrawerIsValue(i)"
                                                        )
                                            template(v-if="cashReport.is !== cashReport.should")
                                                el-form-item(:label="$t('Difference')")
                                                    .el-form-item__content.difference
                                                        .el-input.el-input--medium.is-disabled
                                                            money.el-input__inner(
                                                                :value="cashReport.should - cashReport.is < 0 ? (cashReport.should - cashReport.is) * -1 : cashReport.should - cashReport.is"
                                                                v-bind="getMoneyConfig(cashReport.currency)"
                                                                disabled
                                                            )
                                        .form-row(v-if="!cashReport.paymentMethod.digital")
                                            el-form-item(:prop="`cashReports.${i}.use_denomination`")
                                                el-checkbox(
                                                    size="mini"
                                                    :value="cashReport.use_denomination"
                                                    @change="toggleCashBookDrawerDenomination(cashReport)"
                                                )
                                                    | {{ $t('Specify detailed denominations') }}

                                        transition(name="slide-decent-vertical")
                                            .form-row(v-if="!cashReport.paymentMethod.digital && cashReport.use_denomination && cashReport.denominations.notes")
                                                el-form-item(
                                                    :label="$t('Bill denominations for \"{method}\"', { method: cashReport.payment_method_name })"
                                                    :prop="`cashReports.${i}.denominations.notes`"
                                                )
                                                    .notes(:style="{ '--char-length': getNoteCharWidth(cashReport) }")
                                                        .note(v-for="note in cashReport.denominations.notes")
                                                            label {{ note.value | moneyFormat(cashReport.currency_code, true) }}
                                                            el-input-number(
                                                                v-model="note.count"
                                                                :min="0"
                                                                :step="1"
                                                                :step-strictly="true"
                                                                @change="updateCashBookDrawerDenominationSum(cashReport)"
                                                            )
                                                el-form-item(
                                                    :label="$t('Coin denominations for \"{method}\"', { method: cashReport.payment_method_name })"
                                                    :prop="`cashReports.${i}.denominations.coins`"
                                                )
                                                    .coins(:style="{ '--char-length': getCoinCharWidth(cashReport) }")
                                                        .coin(v-for="coin in cashReport.denominations.coins")
                                                            label {{ coin.value | moneyFormat(cashReport.currency_code, true) }}
                                                            el-input-number(
                                                                v-model="coin.count"
                                                                :min="0"
                                                                :step="1"
                                                                :step-strictly="true"
                                                                @change="updateCashBookDrawerDenominationSum(cashReport)"
                                                            )
                                        .form-row(v-if="showEndOfTheDayTransfer && cashReport.paymentMethod.digital === false")
                                            el-form-item(:label="$t('Amount to take')" :prop="`cashReports.${i}.take`")
                                                //- el-input-number(v-model="cashReport.is" step="0.01" min="0" controls-position="right")
                                                el-input.hidden(v-model="cashReport.take")
                                                .el-form-item__content
                                                    .el-input.el-input--medium(:class="{ 'is-disabled': cashReport.is <= 0 }")
                                                        money.el-input__inner(
                                                            :disabled="cashReport.is <= 0"
                                                            v-model="cashReport.take"
                                                            v-bind="getMoneyConfig(cashReport.currency)"
                                                            @change.native="updateCashBookDrawerTakeValue(i)"
                                                        )
                                            el-form-item(:label="$t('Amount to keep')" :prop="`cashReports.${i}.keep`")
                                                //- el-input-number(v-model="cashReport.is" step="0.01" min="0" controls-position="right")
                                                el-input.hidden(v-model="cashReport.keep")
                                                .el-form-item__content
                                                    .el-input.el-input--medium(:class="{ 'is-disabled': cashReport.is <= 0 }")
                                                        money.el-input__inner(
                                                            :disabled="cashReport.is <= 0"
                                                            v-model="cashReport.keep"
                                                            v-bind="getMoneyConfig(cashReport.currency)"
                                                            @change.native="updateCashBookDrawerKeepValue(i)"
                                                        )
                                        .form-row
                                            el-form-item(:label="$t('Comment')" :prop="`cashReports.${i}.comment`")
                                                el-input(
                                                    type="textarea"
                                                    v-model="cashReport.comment"
                                                    :autosize="{ minRows: 3, maxRows: 8 }"
                                                    maxlength="255"
                                                    show-word-limit
                                                )
                                        //- hr
                                    .form-row.actions
                                        el-button(
                                            size="large"
                                            icon="el-icon-fa-times fas"
                                            @click="closeCashBookDrawer"
                                        ) {{ $t('Dismiss') }}
                                        .right-buttons
                                            //- el-switch(
                                            //-     :active-text="$t('Active')"
                                            //-     inactive-color="#ff4949"
                                            //-     v-model="status"
                                            //- )
                                            el-checkbox(
                                                size="large"
                                                border
                                                v-model="printCashReports"
                                            ) {{ $t('Print PDF') }}
                                            el-button(
                                                size="large"
                                                :disabled="drawer.loading || drawer.saving"
                                                :loading="drawer.saving"
                                                type="primary"
                                                icon="el-icon-fa-check fas"
                                                @click="submitCashReportForm"
                                            ) {{ $t('Save the report') }}
                            .alert.warning.no-margin-top(v-else-if="! drawer.loading") {{ $t('Here is nothing to be reported') }}
            //- .drawer-footer
            //-     el-button(
            //-         round
            //-         size="mini"
            //-         icon="el-icon-fa-times fas"
            //-         @click="closeCashBookDrawer"
            //-     ) {{ $t('Dismiss') }}
            //-     el-button(
            //-         v-if="drawer.tab === 'cash-report'"
            //-         round
            //-         size="mini"
            //-         :disabled="drawer.loading || drawer.saving"
            //-         :loading="drawer.saving"
            //-         type="primary"
            //-         icon="el-icon-fa-check fas"
            //-     ) {{ $t('Save the report and close') }}
            //-     el-button(
            //-         v-else-if="drawer.tab === 'cash'"
            //-         plain
            //-         round
            //-         size="mini"
            //-         :disabled="drawer.loading || drawer.saving"
            //-         :loading="drawer.saving"
            //-         type="primary"
            //-         icon="el-icon-fa-check fas"
            //-     ) {{ $t('Save the cash flow and close') }}
</template>

<i18n>
{
    "en": {
        "Denominations for \"{method}\"": "Denominations for \"{method}\"",
        "Bill denominations for \"{method}\"": "Bill denominations for \"{method}\"",
        "Coin denominations for \"{method}\"": "Coin denominations for \"{method}\"",
        "Checked sum of the payment method \"{method}\"": "Checked sum of the payment method \"{method}\"",
        "Print Receipt #{id}": "Print Receipt #{id}",
        "Print Receipt \\#{id}": "Print Receipt \\#{id}"
    },
    "de": {
        "Cash Book": "Kassenbuch",
        "Currency": "Währung",
        "Comment": "Kommentar",
        "Withdraw Cash": "Bargeld entnehmen",
        "Cash Flow Logs": "Kassenbewegung",
        "Cash Report": "Kassenabschluss",
        "Deposit Cash": "Bargeld einzahlen",
        "Amount to take": "Aus der Kasse nehmen",
        "Amount to keep": "In der Kasse behalten",
        "Amount": "Betrag",
        "Actual Sum": "Tatsächliche Summe",
        "Denominations for \"{method}\"": "Stückelung für \"{method}\"",
        "Bill denominations for \"{method}\"": "Scheinstückelung für \"{method}\"",
        "Coin denominations for \"{method}\"": "Münzstückelung für \"{method}\"",
        "Specify detailed denominations": "Detaillierte Stückelung angeben",
        "Checked sum of the payment method \"{method}\"": "Kontrollierte Summe der Zahlungsart \"{method}\"",
        "Difference": "Differenz",
        "Purchase": "Verkauf",
        "Logs could not be fetched": "Kassenbewegung konnte nicht abgerufen werden",
        "No more logs found": "Es gibt keine weiteren Einträge",
        "Save the report and close": "Kassenabschluss speichern und schließen",
        "Save the report": "Kassenabschluss speichern",
        "Save the cash flow and close": "Kassenbewegung speichern und schließen",
        "Here is nothing to be reported": "Hier gibt es nichts abzuschließen",
        "Print PDF": "PDF drucken",
        "Withdrawal / Deposit": "Entnahme / Einlage",
        "Cash Report saved successfully!": "Kassenabschluss erfolgreich gespeichert!",
        "Cash Report could not be created": "Kassenabschluss konnte nicht erstellt werden",
        "Withdrawal could not be saved": "Betrag konnte nicht ausgebucht werden",
        "Cash withdrawn successfully": "Betrag erfolgreich ausgebucht",
        "Cash deposited successfully": "Betrag erfolgreich eingebucht",
        "Deposit could not be saved": "Betrag konnte nicht eingebucht werden",
        "There is no cash flow since the last report": "Seit dem letzten Kassenabschluss gab es keine Kassenbewegung",
        "There is no cash flow": "Bis jetzt gab es keine Kassenbewegung",
        "Cash Report Transfer": "Kassenabschluss Übetrag",
        "Could not print the cash report PDF!": "Kassenabschluss PDF konnte nicht gedruckt werden!",
        "The cash report PDF is still being generated": "Das Kassenabschluss PDF wird noch erstellt",
        "Print it from the cash book in a few minutes.": "Drucken Sie es in einigen Minuten aus dem Kassenbuch.",
        "Refund": "Rückzahlung",
        "Charge": "Einnahme",
        "Print Receipt #{id}": "Beleg #{id} drucken",
        "The fiscal security device (TSE) is not available. Please try again later.": "Die technische Sicherheitseinrichtung (TSE) ist nicht erreichbar. Bitte versuchen Sie es später erneut."
    }
}
</i18n>

<script>
import printJS from 'print-js-updated';
import { moneyFormat, timestamp2date } from '@/filters'
import { useAuthStore, useSetupStore, usePosSetupStore } from '@/stores'

import {
    hasDenominations,
    getDenominations,
    getNotes,
    getCoins,
    getHighestNote,
    getHighestCoin,
    getLowestNote,
    getLowestCoin
} from 'currency-denominations';

import CashFlowLogApi from '@/extensions/shop/pointOfSale/store/api/cashFlowLog';
import CashReportApi from '@/extensions/shop/pointOfSale/store/api/cashReport';
import AuthApi from '@/store/api/system/auth';

import CashFlowLogReportRows from './CashFlowLogReportRows'

import { Money } from 'v-money'
import cashReport from '../../store/api/cashReport';

export default {
    name: 'CashBookDrawer',
    data() {
        return {
            withdrawOnly: false,
            drawer: {
                visibility: false,
                loading: false,
                saving: false,
                tab: undefined,
                paginatedCashFlowLogs: [],
                form: {
                    cashReports: [],
                    cashFlowLogs: {},
                },
                rules: {
                    cashReports: [],
                    cashFlowLogs: {},
                },
            },
        };
    },
    components: {
        CashFlowLogReportRows,
        Money,
    },
    filters: {
        moneyFormat,
        timestamp2date
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore();
        },
        setupStore() {
            return useSetupStore();
        },
        printCashReports: {
            get() {
                const key = 'ex:shop_pos:print_cash_reports';
                const misc = _.get(this.user, 'settings.misc') || [];
                const setting = misc.find(item => item.key === key)

                const value = _.get(setting, 'value') || 'false'
                return value === 'true'
            },
            set(value) {
                const key = 'ex:shop_pos:print_cash_reports';
                this.saveMiscSettings({ key, value: value.toString() })
            }
        },
        currencyOptions() {
            return _.get(this.activeCms.shop, 'currencies') || [];
        },
        showEndOfTheDayTransfer() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'pos:show-end-of-the-day-transfer');
        },
        user() {
            return useAuthStore().user;
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        options() {
            return this.posSetupStore.options;
        },
    },
    methods: {
        openCashBookDrawerWithPrefill({ paymentMethodId, amount, comment, withdrawOnly }) {
            // Store prefill data to apply after drawer is loaded
            this._prefillData = { paymentMethodId, amount, comment, withdrawOnly };
            this.openCashBookDrawer();
        },
        openCashBookDrawer() {
            this.drawer.loading = true;
            this.drawer.visibility = true;

            this.$emit('blur-search');
            this.updateAutofocusSearchInput(false);

            let actions = []
            this.options.paymentMethod.items.forEach(paymentMethod => {
                const payload = {
                    filters: {
                        pointOfSale: {
                            key: 'pointOfSale',
                            match: this.activePointOfSale.id
                        },
                        paymentMethod: {
                            key: 'paymentMethod',
                            match: paymentMethod.id
                        },
                        // isReported: {
                        //     key: 'isReported',
                        //     match: false
                        // }
                    },
                    pageInfo: {
                        total: 0,
                        perPage: 12,
                        currentPage: 1,
                        lastPage: 0,
                    },
                    items: []
                }

                const cashFlowLogs = { paymentMethod, pagination: undefined }
                this.drawer.paginatedCashFlowLogs.push(cashFlowLogs)

                // if (paymentMethod.digital === false) {
                    const currency = _.get(this.activePointOfSale, 'customerGroup.currency')
                        || _.get(this.activeCms.shop, 'defaultCustomerGroup.currency');

                    this.$set(this.drawer.form.cashFlowLogs, paymentMethod.id, {
                        direction: 'in',
                        amount: 0,
                        comment: '',
                        pointOfSale: this.activePointOfSale,
                        paymentMethod,
                        currency
                    })
                    this.$set(this.drawer.rules.cashFlowLogs, paymentMethod.id, {
                        amount: 'required|min_value:0.01',
                    })

                    if (this.drawer.tab === undefined) this.drawer.tab = paymentMethod.id
                // }

                const action = CashFlowLogApi.fetchCashFlowLogsPaginated(payload)
                    .then(pagination => {
                        if (pagination.items.length) {
                            // if (this.drawer.tab === undefined) this.drawer.tab = paymentMethod.id
                            // const cashFlowLogs = { paymentMethod, pagination }
                            // this.drawer.paginatedCashFlowLogs.push(cashFlowLogs)
                            cashFlowLogs.pagination = pagination
                            cashFlowLogs.pagination.filters = payload.filters
                        }
                    })
                actions.push(action)
            })

            const initializeCashReports = CashReportApi.initializeCashReports(this.activePointOfSale.id)
                .then(cashReports => {
                    this.drawer.form.cashReports = _.cloneDeep(cashReports)
                    if (cashReports.length) {
                        cashReports.forEach((el, i) => {
                            let rules = {
                                is: 'required|min_value:0.00',
                                take: 'min_value:0.00|max_value:0.00',
                                keep: 'min_value:0.00|max_value:0.00',
                            };

                            if (el.paymentMethod.digital === true) {
                                rules = {
                                    is: 'required',
                                    take: 'max_value:0.00',
                                    keep: 'max_value:0.00',
                                };
                            } else if (hasDenominations(el.currency.iso4217)) {
                                this.$set(this.drawer.form.cashReports[i], 'use_denomination', false)
                            }

                            if (el.should !== el.is) {
                                rules.comment = 'required'
                            }

                            this.$set(this.drawer.rules.cashReports, i, rules)
                        })
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    console.error(err)
                })
            actions.push(initializeCashReports)

            Promise.all(actions)
                .catch(error => {
                    console.error(error)
                    this.$notify.error({
                        title: this.$t('Logs could not be fetched'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    const cashFlowLogs = this.drawer.paginatedCashFlowLogs.filter(el => el.pagination)
                    if (this.drawer.tab === undefined && cashFlowLogs.length) {
                        this.drawer.tab = cashFlowLogs[0].paymentMethod.id
                    }

                    this.drawer.loading = false;
                    if (this.drawer.tab === undefined) {
                        this.drawer.tab = 'cash-report'
                    } else {
                        const cashFlowLogs = this.drawer.paginatedCashFlowLogs.find(el => {
                            return el.paymentMethod.id === this.drawer.tab
                        })
                        this.$nextTick(() => {
                            this.loadMoreCashFlowLogsIfNeeded(this.$refs[`cash-flow-logs-${this.drawer.tab}`], cashFlowLogs)
                        })
                    }

                    // Apply prefill data if present (from remaining coupon amount)
                    if (this._prefillData) {
                        const { paymentMethodId, amount, comment, withdrawOnly } = this._prefillData;
                        this.drawer.tab = paymentMethodId;
                        if (this.drawer.form.cashFlowLogs[paymentMethodId]) {
                            this.$set(this.drawer.form.cashFlowLogs[paymentMethodId], 'direction', 'out');
                            this.$set(this.drawer.form.cashFlowLogs[paymentMethodId], 'amount', amount);
                            this.$set(this.drawer.form.cashFlowLogs[paymentMethodId], 'comment', comment);
                        }
                        this.withdrawOnly = !!withdrawOnly;
                        this._prefillData = null;
                    }
                })

            // this.$refs.search.blur();
        },
        // getNotes,
        // getCoins,
        // getHighestNote,
        // getHighestCoin,
        // getLowestNote,
        // getLowestCoin,
        // moneyFormat,

        getCoinCharWidth(cashReport) {
            const max = moneyFormat(getHighestCoin(cashReport.currency_code), cashReport.currency_code, true).length
            const min = moneyFormat(getLowestCoin(cashReport.currency_code), cashReport.currency_code, true).length
            return Math.max(min, max);
        },
        getNoteCharWidth(cashReport) {
            const max = moneyFormat(getHighestNote(cashReport.currency_code), cashReport.currency_code, true).length
            const min = moneyFormat(getLowestNote(cashReport.currency_code), cashReport.currency_code, true).length
            return Math.max(min, max);
        },

        updateCashBookDrawerDenominationSum(cashReport) {
            let notes = cashReport.denominations.notes || [];
            let coins = cashReport.denominations.coins || [];

            let sum = 0;
            notes.forEach(note => {
                sum += note.value * note.count;
            });
            coins.forEach(coin => {
                sum += coin.value * coin.count;
            });

            cashReport.is = sum;
            this.updateCashBookDrawerIsValue(this.drawer.form.cashReports.indexOf(cashReport));
        },

        getMoneyConfig(currency) {
            let moneyConfig = {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: ' ' + _.get(currency, 'sign'),
                precision: 2,
                masked: false
            }
            switch (currency.iso4217) {
                case 'USD':
                    moneyConfig.decimal = '.';
                    moneyConfig.thousands = ',';
                    moneyConfig.suffix = '';
                    moneyConfig.prefix = _.get(currency, 'sign') + ' ';
                    break;
            }
            return moneyConfig
        },
        canWithdrawThatAmount(paymentMethod) {
            if (paymentMethod.digital === true) return true

            const amount = _.get(this.drawer.form.cashFlowLogs, `${paymentMethod.id}.amount`) || 0
            const currency = _.get(this.drawer.form.cashFlowLogs, `${paymentMethod.id}.currency`)
            const cashReport = this.drawer.form.cashReports.find(el => {
                return el.paymentMethod.id === paymentMethod.id && el.currency.id === currency.id
            })

            let canWithdraw = true
            if (! cashReport || ! currency || cashReport.should < amount) canWithdraw = false
            return canWithdraw
        },
        withdrawCash(form) {
            this.$refs[`cash-flow-logs-${form.paymentMethod.id}-form`][0].validate((valid, errors) => {
                if (valid) {
                    let payload = _.cloneDeep(form);
                    payload.direction = 'out';

                    this.drawer.saving = true;
                    CashFlowLogApi.create(payload)
                        .finally(() => {
                            this.drawer.saving = false;
                        })
                        .then(cashFlowLog => {
                            this.$notify.success({
                                title: this.$t('Cash withdrawn successfully'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                            this.printCashMovementReceipt(cashFlowLog, true);
                        })
                        .catch(error => {
                            console.error(error)
                            var serverMessage = _.get(error, 'graphQLErrors.0.message', '') || ''
                            var isTseError = serverMessage.indexOf('TSE') > -1
                            this.$notify.error({
                                title: this.$t('Withdrawal could not be saved'),
                                message: isTseError ? this.$t('The fiscal security device (TSE) is not available. Please try again later.') : '',
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: isTseError ? 15000 : 8000
                            });
                        })
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },
        depositCash(form) {
            this.$refs[`cash-flow-logs-${form.paymentMethod.id}-form`][0].validate((valid, errors) => {
                if (valid) {
                    let payload = _.cloneDeep(form);
                    payload.direction = 'in';

                    this.drawer.saving = true;
                    CashFlowLogApi.create(payload)
                        .finally(() => {
                            this.drawer.saving = false;
                        })
                        .then(cashFlowLog => {
                            this.$notify.success({
                                title: this.$t('Cash deposited successfully'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                            this.printCashMovementReceipt(cashFlowLog, true);
                        })
                        .catch(error => {
                            console.error(error)
                            var serverMessage = _.get(error, 'graphQLErrors.0.message', '') || ''
                            var isTseError = serverMessage.indexOf('TSE') > -1
                            this.$notify.error({
                                title: this.$t('Deposit could not be saved'),
                                message: isTseError ? this.$t('The fiscal security device (TSE) is not available. Please try again later.') : '',
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: isTseError ? 15000 : 8000
                            });
                        })
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },
        toggleCashBookDrawerDenomination(cashReport) {
            cashReport.use_denomination = !cashReport.use_denomination;
            // this.$set(cashReport, 'denominations', {
            //     notes: Object.fromEntries(getNotes(cashReport.currency.iso4217).map(value => [value, 0])),
            //     coins: Object.fromEntries(getCoins(cashReport.currency.iso4217).map(value => [value, 0])),
            // })

            this.$set(cashReport, 'denominations', {
                notes: getNotes(cashReport.currency.iso4217).map(value => ({ value, count: 0 })),
                coins: getCoins(cashReport.currency.iso4217).map(value => ({ value, count: 0 })),
            })

            if (cashReport.use_denomination) {
                this.updateCashBookDrawerDenominationSum(cashReport);
            }
        },
        updateCashBookDrawerIsValue(i) {
            // console.log('is')
            let cashReport = this.drawer.form.cashReports[i];
            let rules = this.drawer.rules.cashReports[i];

            if (cashReport.paymentMethod.digital === false) {
                this.$set(rules, 'take', `min_value:0.00|max_value:${Math.max(cashReport.is, 0)}`)
                this.$set(rules, 'keep', `min_value:0.00|max_value:${Math.max(cashReport.is, 0)}`)
            } else {
                this.$set(rules, 'take', `max_value:${Math.max(cashReport.is, 0)}`)
                this.$set(rules, 'keep', `max_value:${Math.max(cashReport.is, 0)}`)
            }

            if (cashReport.should !== cashReport.is) {
                this.$set(rules, 'comment', 'required')
            } else {
                this.$delete(rules, 'comment')
            }

            cashReport.keep = cashReport.is;
        },
        updateCashBookDrawerTakeValue(i) {
            this.$nextTick(() => {
                // console.log('take')
                let cashReport = this.drawer.form.cashReports[i];
                // let rules = this.drawer.rules.cashReports[i];

                cashReport.keep = cashReport.is - cashReport.take;
            })
        },
        updateCashBookDrawerKeepValue(i) {
            this.$nextTick(() => {
                // console.log('keep')
                let cashReport = this.drawer.form.cashReports[i];
                // let rules = this.drawer.rules.cashReports[i];

                cashReport.take = cashReport.is - cashReport.keep;
            })
        },

        changeCashBookDrawerTab(tab) {
            if (tab.name !== 'cash-report') {
                const cashFlowLogs = this.drawer.paginatedCashFlowLogs.find(el => {
                    return el.paymentMethod.id === tab.name
                })
                this.$nextTick(() => {
                    this.loadMoreCashFlowLogsIfNeeded(this.$refs[`cash-flow-logs-${tab.name}`], cashFlowLogs)
                })
            }
        },
        handleCashBookDrawerScroll(event, cashFlowLogs) {
            const { target } = event;
            this.loadMoreCashFlowLogsIfNeeded(target, cashFlowLogs)
        },
        loadMoreCashFlowLogsIfNeeded(target, cashFlowLogs) {
            if (! cashFlowLogs.pagination) return;

            if (Array.isArray(target) && target.length === 1) target = target[0]

            const currentPage = cashFlowLogs.pagination.pageInfo.currentPage;
            if (target && cashFlowLogs.pagination.loading !== true && cashFlowLogs.pagination.pageInfo.lastPage > currentPage) {

                let loadMore = false;
                // const offset = window.innerHeight * 0.8;
                const offset = window.innerHeight;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight - offset) loadMore = true;

                if (loadMore) {
                    this.$set(cashFlowLogs.pagination, 'loading', true);
                    this.loadCashFlowLogsIntoDrawer(cashFlowLogs, currentPage + 1)
                }
            }
        },
        async loadCashFlowLogsIntoDrawer(cashFlowLogs, page = 1) {
            this.$set(cashFlowLogs.pagination.pageInfo, 'currentPage', page)

            const paginatedCashFlowLogs = await CashFlowLogApi.fetchCashFlowLogsPaginated(cashFlowLogs.pagination)
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    console.error(err)
                })

            if (paginatedCashFlowLogs.items && paginatedCashFlowLogs.items.length) {
                if (page > 1) {
                    cashFlowLogs.pagination.items = [...cashFlowLogs.pagination.items, ...paginatedCashFlowLogs.items]
                } else {
                    const filters = cashFlowLogs.filters
                    cashFlowLogs.pagination = paginatedCashFlowLogs;
                    cashFlowLogs.pagination.filters = filters
                }
            } else {
                this.$notify.error({
                    title: this.$t('No more logs found'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            }

            this.$nextTick(() => {
                this.loadMoreCashFlowLogsIfNeeded(this.$refs[`cash-flow-logs-${cashFlowLogs.paymentMethod.id}`], cashFlowLogs)
            })

            cashFlowLogs.loading = false;
            this.$set(cashFlowLogs.pagination, 'loading', false);
        },
        printCashMovementReceipt(cashFlowLog, closeDrawerAfter) {
            var self = this;
            var tillRoll = _.get(cashFlowLog, 'latestTillRoll');
            if (!tillRoll) {
                if (closeDrawerAfter) {
                    self.drawer.visibility = false;
                    self.updateAutofocusSearchInput(true);
                }
                return;
            }

            var storageRoute = _.trim(process.env.VUE_APP_API_ENDPOINT + process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE, '/');
            var token = AuthApi.getToken();
            var printable = storageRoute + '/files/' + tillRoll.id + '/' + tillRoll.name + '?token=' + token;

            printJS({
                printable,
                onError: function() {
                    self.$notify.error({
                        title: self.$t('An error occurred!'),
                        message: self.$t('Could not print the cash movement receipt PDF!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    });
                    if (closeDrawerAfter) {
                        self.drawer.visibility = false;
                        self.updateAutofocusSearchInput(true);
                    }
                },
                onPrintDialogClose: function() {
                    if (closeDrawerAfter) {
                        self.drawer.visibility = false;
                        self.updateAutofocusSearchInput(true);
                    }
                },
            });
        },
        submitCashReportForm() {
            this.$refs.cashReportForm.validate((valid, errors) => {
                if (valid) {
                    this.drawer.saving = true;
                    CashReportApi.createCashReports(this.activePointOfSale, this.drawer.form.cashReports)
                        .then(cashReports => {
                            const file = cashReports[0].file
                            if (this.printCashReports && !file) {
                                // The PDF is rendered again in the background; the cash book offers it once it exists.
                                this.drawer.saving = false;
                                this.closeCashBookDrawer();
                                this.$notify.warning({
                                    title: this.$t('The cash report PDF is still being generated'),
                                    message: this.$t('Print it from the cash book in a few minutes.'),
                                    iconClass: 'fas el-icon-fa-clock',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000,
                                })
                            } else if (this.printCashReports) {
                                const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
                                let table = 'files'

                                const token = AuthApi.getToken()
                                const printable = `${storageRoute}/${table}/${file.id}/${file.name}?token=${token}`

                                printJS({
                                    printable,
                                    onLoadingEnd: () => {
                                        // Don't close drawer here - wait for print dialog
                                    },
                                    onError: () => {
                                        this.drawer.saving = false;
                                        this.closeCashBookDrawer();
                                        this.$notify.error({
                                            title: this.$t('An error occurred!'),
                                            message: this.$t('Could not print the cash report PDF!'),
                                            iconClass: 'fas el-icon-fa-times',
                                            position: 'bottom-left',
                                            customClass: 'dark',
                                            duration: 8000,
                                        })
                                    },
                                    onPrintDialogClose: () => {
                                        this.drawer.saving = false;
                                        this.closeCashBookDrawer();
                                    }
                                })
                            } else {
                                this.drawer.saving = false;
                                this.closeCashBookDrawer();
                            }
                            this.$notify.success({
                                title: this.$t('Cash Report saved successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })
                        .catch(error => {
                            console.error(error)
                            this.drawer.saving = false;
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Cash Report could not be created'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },
        closeCashBookDrawer() {
            this.drawer.visibility = false;
        },
        resetCashBookDrawer() {
            this.withdrawOnly = false;
            this.drawer = {
                visibility: false,
                loading: false,
                saving: false,
                tab: undefined,
                paginatedCashFlowLogs: [],
                form: {
                    cashReports: [],
                    cashFlowLogs: {},
                },
                rules: {
                    cashReports: [],
                    cashFlowLogs: {},
                },
            }
            this.updateAutofocusSearchInput(true);
        },
        updateAutofocusSearchInput(value) {
            this.posSetupStore.updateAutofocusSearchInput(value);
        },
        saveMiscSettings(payload) {
            return this.setupStore.saveMiscSettings(payload);
        },
    },
};
</script>

<style lang="sass" scoped>
.cash-book-drawer
    .drawer-body
        flex-grow: 1
        overflow: auto
        padding: 0
        max-height: calc(100vh - 66px) // - 69px
        .cash-flow-log
            flex-grow: 1
            .in
                color: $--color-success
            .out
                color: $--color-danger
            .row
                display: flex
                gap: 0.5rem
                span + span:before
                    content: ' '
                .amount, .by
                    flex-grow: 1
                & + .row
                    margin-top: 0.5rem
                .gray
                    color: $color-grey-text
        .reported-header i
            color: $--shop-color-primary
        hr
            flex-grow: 1
            opacity: 0.5
            width: 100%
        .tab
            line-height: 1.3
            // padding-top: 0.5rem
            // padding-bottom: 0.5rem
            padding-top: 4px
            padding-bottom: 4px
            .total
                margin-top: 2px
                // font-size: 0.8rem
                color: $color-grey-text
                // font-weight: normal
        &::v-deep
            .el-tabs__item
                min-height: 36px
                height: auto
                .el-button
                    width: 100%
                    text-align: right
                &.is-active
                    .el-button
                        color: $--shop-color-primary
                        background: lighten($--shop-color-primary, 35%)
                        border-color: lighten($--shop-color-primary, 25%)
                        .total
                            color: #916BDB
                // & > .tab
                //     border: 1px solid
                //     padding-left: 1rem
                //     padding-right: 1rem
                //     border-radius: 4px
                //     margin: 4px 0
                // & + .el-tabs__item > .tab
                //     // margin-top: 0.5rem
            .el-tabs__active-bar
                transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)
    .el-form
        padding-bottom: 20px
        h2.title
            display: flex
            font-size: 1.4rem
            justify-content: space-between
            .gray
                color: $color-grey-text
                margin-left: 0.25em
                display: none
            .small
                color: $color-grey-text
                font-size: 1rem
        .form-row
            display: flex
            gap: 1rem
            & > *:not(.dont-grow)
                flex-grow: 1
            &.actions
                justify-content: space-between
                & > *
                    flex-grow: 0
                .right-buttons
                    display: flex
                    gap: 1rem
                    align-items: center
            .difference .v-money
                font-weight: bold
                color: $--color-danger
    .scroll-box
        max-height: calc(100vh - 66px) // - 69px
        padding-right: 20px
        overflow: auto
    .cash-report + .cash-report
        margin-top: 2rem
    .is-reported .row > *:not(.highlight)
        opacity: 0.5

    &::v-deep .el-loading-mask
        background-color: rgba(255, 255, 255, 0.6) !important

.no-margin-top
    margin-top: 0

.tab-content
    width: 100%
    display: flex
    flex-direction: column

.notes, .coins
    display: flex
    flex-direction: column
    gap: 0.5rem
.note, .coin
    label
        font-family: 'Fira Code', 'Courier New', Courier, monospace
        width: calc(var(--char-length, 3) * 1ch + 0.8rem)
        display: inline-block
        text-align: right
        padding-right: 0.8rem
        // padding-left: 0.5rem
        // background: #f5f7fa
        border-top-left-radius: 4px
        border-bottom-left-radius: 4px
        color: #838487
        z-index: 0
        right: -4px
        position: relative
        margin-left: -4px
</style>
